import script from "./PickChoice.vue?vue&type=script&setup=true&lang=js"
export * from "./PickChoice.vue?vue&type=script&setup=true&lang=js"

import "./PickChoice.vue?vue&type=style&index=0&id=4811f89c&lang=scss&scoped=true"

import exportComponent from "/builds/strooka-jagaad/strooka-fe/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4811f89c"]])

export default __exports__